import { Box, Typography, styled } from "@mui/material";
import { FormSelectInput } from "@/components/custom/custom-form-select-input";
import { FormTextInput } from "@/components/custom/custom-form-text-input";
import { CustomButton } from "@/components/custom/custom-button";

const Wrapper = styled(Box)(({ theme }) => ({
  display: "flex",
  flexDirection: "column",
  gap: theme.spacing(3),
}));

const Row = styled(Box)(({ theme }) => ({
  display: "flex",
  flexDirection: "column",
  gap: theme.spacing(3),

  [theme.breakpoints.up("lg")]: {
    flexDirection: "row",
  },
}));

const Side = styled(Box)(({ theme }) => ({
  flexShrink: 0,

  [theme.breakpoints.up("lg")]: {
    width: 256,
  },
}));

const Content = styled(Box)(({ theme }) => ({
  flex: 1,
  display: "flex",
  flexDirection: "column",
  gap: theme.spacing(2),
}));

const Grid = styled(Box)(({ theme }) => ({
  display: "grid",
  gridTemplateColumns: "1fr",
  gap: theme.spacing(2),

  [theme.breakpoints.up("md")]: {
    gridTemplateColumns: "1fr 1fr",
  },
}));

export const AdminProfileDetails = ({ formik, isDisabled }) => {
  return (
    <Wrapper>
      <Row>
        <Side>
          <Typography fontWeight={500} fontSize={18}>
            Personal Information
          </Typography>
          <Typography variant="body2" color="text.secondary">
            Update your personal information here.
          </Typography>
        </Side>

        <Content>
          <Grid>
            <FormTextInput
              formik={formik}
              name="firstName"
              label="First Name"
              isDisabled={isDisabled}
            />

            <FormTextInput
              formik={formik}
              name="lastName"
              label="Last Name"
              isDisabled={isDisabled}
            />

            <FormTextInput
              formik={formik}
              name="email"
              label="Email"
              type="email"
              isDisabled={isDisabled}
            />

            <FormTextInput
              formik={formik}
              name="phoneNumber"
              label="Phone Number"
              isDisabled={isDisabled}
            />

            <FormSelectInput
              formik={formik}
              name="gender"
              label="Gender"
              options={[
                { value: "MALE", label: "Male" },
                { value: "FEMALE", label: "Female" },
              ]}
              isDisabled={isDisabled}
            />

            <FormTextInput
              formik={formik}
              name="address"
              label="Address"
              isDisabled={isDisabled}
            />

            <FormTextInput
              formik={formik}
              name="district"
              label="District"
              isDisabled={isDisabled}
            />

            <FormTextInput
              formik={formik}
              name="city"
              label="City"
              isDisabled={isDisabled}
            />

            <FormTextInput
              formik={formik}
              name="state"
              label="State"
              isDisabled={isDisabled}
            />

            <FormSelectInput
              formik={formik}
              name="isActive"
              label="Account Status"
              options={[
                { value: true, label: "Active" },
                { value: false, label: "Inactive" },
              ]}
              isDisabled={true}
            />
          </Grid>

          <Box display="flex" justifyContent="flex-end">
            <CustomButton
              type="submit"
              variantType="outline"
              size="small"
              disabled={!formik.isValid || !formik.dirty}
              sx={{
                width: "fit-content",
                px: 2,
              }}
            >
              Save Changes
            </CustomButton>
          </Box>
        </Content>
      </Row>
    </Wrapper>
  );
};
